import React, { useContext, useEffect, useState } from 'react';

import Count from '@totem/components/common/Count';
import SummaryContext from '@totem/components/portfolio/overview/summary/summaryContext';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { isNotNull } from '@totem/utilities/common';

import './summary.css';

const styles = {
  card: {
    margin: '2rem 0',
    width: '100%',
  },
  cardHeader: {},
  cardBody: {
    paddingTop: 0,
    height: '34rem',
  },
};

const PortfolioCounts = () => {
  const { filteredRegions } = useContext(SummaryContext);
  const [regionCount, setRegionCount] = useState<number>(0);
  const [buildingCount, setBuildingCount] = useState<number>(0);
  const [controlSystemCount, setControlSystemCount] = useState<number>(0);

  useEffect(() => {
    if (isNotNull(filteredRegions)) {
      setRegionCount(filteredRegions.length);
      let totalBuildings = 0;
      let totalControlSystems = 0;
      for (let idx = 0; idx < filteredRegions.length; idx++) {
        totalBuildings += filteredRegions[idx].buildings.length;
        for (
          let bIdx = 0;
          bIdx < filteredRegions[idx].buildings.length;
          bIdx++
        ) {
          totalControlSystems +=
            filteredRegions[idx].buildings[bIdx].controlSystems.length;
        }
      }
      setBuildingCount(totalBuildings);

      setControlSystemCount(totalControlSystems);
    }
  }, [filteredRegions]);

  return (
    <IBCard
      title={'Summary'}
      style={styles.card}
      styles={{ body: styles.cardBody }}
    >
      <div styleName="details-container">
        <div styleName="details-label">Regions</div>
        <Count count={regionCount} size="large" />
      </div>
      <div styleName="details-container">
        <div styleName="details-label">Buildings</div>
        <Count count={buildingCount} size="large" />
      </div>
      <div styleName="details-container">
        <div styleName="details-label">Control Systems</div>
        <Count count={controlSystemCount} size="large" />
      </div>
    </IBCard>
  );
};

export default PortfolioCounts;
